var _rect, _rect2, _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 70,
    height: 70,
    rx: 15,
    stroke: "url(#paint0_linear_771_124)",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 32,
    height: 28,
    rx: 5,
    stroke: "url(#paint1_linear_771_124)",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 30,
    r: 3,
    fill: "url(#paint2_linear_771_124)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 49L29 38L35 44L44 34L52 49H20Z",
    fill: "url(#paint3_linear_771_124)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20V10M61 14L57 10L53 14",
    stroke: "url(#paint4_linear_771_124)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_771_124",
    x1: -18,
    y1: 18,
    x2: 54,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7852F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84AEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_771_124",
    x1: 10.5,
    y1: 28.5,
    x2: 40.2665,
    y2: 62.2354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7852F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84AEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_771_124",
    x1: 24.5,
    y1: 28.5,
    x2: 30.5,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7852F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84AEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_771_124",
    x1: 12,
    y1: 37.75,
    x2: 23.5292,
    y2: 62.3457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7852F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84AEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_771_124",
    x1: 51,
    y1: 12.5,
    x2: 60.7561,
    y2: 20.3049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7852F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84AEF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlaceholder);
export default __webpack_public_path__ + "static/media/logo_placeholder.9a2b733e6557418431e8bd8773ae82ad.svg";
export { ForwardRef as ReactComponent };